/* eslint-disable max-statements */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import {
	QueryClient,
	QueryClientProvider,
	useQuery,
	useQueryClient
} from 'react-query';
import { useDispatch } from 'react-redux';
import { globalEnv } from '../../../../config/baseConfig';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { setSearchPlaceholderAction } from '../../../../redux/actions/searchBarAction';
import {
	setSelectedSection,
	setTab
} from '../../../../redux/actions/sideBarAction';
import { sortingOrder } from '../../../Utils/sortingOrder';
import Pagination from '../../../Utils/Pagination';
import DiscoverTopicCard from './topicCard';
import LoadingSquaresAnimation from '../../../Utils/LoadingAnimations/LoadingSqauresAnimation';
import { useSearchParams } from 'react-router-dom';
import axiosInstance from '../../../../config/axiosInstance';
import { LogoutAction } from '../../../../redux/actions/authAction';

const queryClient = new QueryClient();

export default function DiscoverTopics() {
	const dispatch = useDispatch();
	dispatch(setSelectedSection('Discover Meavana topics'));
	dispatch(setSearchPlaceholderAction('Search for Topics'));
	dispatch(setTab('documents'));
	return (
		<QueryClientProvider client={queryClient}>
			<div className="w-full h-full pt-16 pl-18 min-w-200">
				<Scrollbars autoHide>
					<DiscoverTopicsComponent />
				</Scrollbars>
			</div>
		</QueryClientProvider>
	);
}

function DiscoverTopicsComponent() {
	const queryClient = useQueryClient();

	const [searchParams, setSearchParams] = useSearchParams();
	const urlPage = searchParams.get('page');
	const [page, setPage] = useState(
		urlPage != null && !isNaN(parseInt(urlPage)) ? parseInt(urlPage) : 1
	);
	const [sortOrder, setSortOrder] = useState(sortingOrder.DESCENDING);
	const [selectedHeader, setSelectedHeader] = useState('createdAt');
	const [topics, setTopics] = useState([]);
	//Privacy
	const [isMine, setIsMine] = useState(false);

	const { searchQuery }: { searchQuery: string } = useTypedSelector(
		(state) => state.searchbar
	);

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const dispatch = useDispatch();

	useEffect(() => {
		if (page != null) {
			if (page === 1) {
				searchParams.delete('page');
				setSearchParams(searchParams);
			} else history.pushState(history.state, 'documents', `?page=${page}`);
		}
	}, [page]);

	const { data, isError, isSuccess, isFetching, isLoading } = useQuery(
		['users', page, selectedHeader, sortOrder, searchQuery],
		() => fetchTopics(page),
		{ keepPreviousData: true, staleTime: 5000, refetchOnWindowFocus: false }
	);

	// Prefetch the next page!
	useEffect(() => {
		if (data?.hasMore) {
			queryClient.prefetchQuery(['users', page + 1], () =>
				fetchTopics(page + 1)
			);
		}
	}, [data, page, queryClient]);

	useEffect(() => {
		try {
			setTopics(data.topics);
		} catch (e) {
			console.log('Error getting data');
		}
	}, [data]);

	async function fetchTopics(page: number) {
		const { data } = await axiosInstance().get(
			globalEnv.BASE_URL +
				`/topic/get-all-editor?page=${page}&sortby=${selectedHeader}&order=${sortOrder}${
					searchQuery !== '' ? '&filter=' + searchQuery : ''
				}`
		);
		if (data.meta.pages < page) {
			setPage(1);
		}
		return data;
	}

	return (
		<main className="mb-20 w-full">
			<section className="mx-auto px-0 md:px-4 py-4">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 justify-items-center gap-4">
					{isFetching || isLoading ? (
						<LoadingSquaresAnimation />
					) : (
						topics.map((item: any) => (
							<DiscoverTopicCard
								key={item._id}
								id={item._id}
								name={item.name}
								createdAt={item.createdAt}
								imagesCount={item.imagesCount}
								usersCount={item.usersCount}
								image={item.backgroundImage}
								creator={item.creator}
								tags={item.tags}
							/>
						))
					)}
				</div>
			</section>
			{isSuccess && (
				<div className="flex justify-center mt-3 mb-20">
					<Pagination
						itemsPerPage={data.meta.limit}
						totalCount={data.meta.total}
						totalPages={data.meta.pages}
						currentPage={page}
						setPage={setPage}
					/>
				</div>
			)}
		</main>
	);
}
